import { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import classes from './MAIN.module.scss';
import { ComponentProps } from './MAIN.model';
import LoginPage from '../LoginPage/LoginPage';

//Az app vagy fő komponenst elnevezése.
//TODO: megadni a nevét, de a mappa nevet nem változtatni!!!
function MAIN(props: ComponentProps, ref: any) {
	useImperativeHandle(ref, () => ({
		testlog: () => {
			console.log('REF teszt');
		},
	}));
	return (
		<LoginPage
			alias={props.alias}
			onLogin={(hash: string) => {
				if (props.handleLogin) {
					props.handleLogin(hash);
				}
			}}
			translates={props.translates}
			countryCode={props.countryCode}
			governmentIdType={props.governmentIdType}
		/>
	);
}

export default forwardRef(MAIN);
